import { useLayoutEffect, useRef, useState } from "react";

/** The element's inner width, so a drawing wraps where its column ends. */
export function useElementWidth(fallback: number): [React.RefObject<HTMLDivElement | null>, number] {
	const ref = useRef<HTMLDivElement | null>(null);
	const [width, setWidth] = useState(fallback);
	useLayoutEffect(() => {
		const el = ref.current;
		if (!el || typeof ResizeObserver === "undefined") return;
		const read = () => setWidth(Math.max(120, Math.floor(el.clientWidth)));
		read();
		const observer = new ResizeObserver(read);
		observer.observe(el);
		return () => observer.disconnect();
	});
	return [ref, width];
}

/** Measures with the real font when a canvas is to hand, the estimate otherwise. */
export function canvasMeasurer(font: string, estimate: (text: string) => number): (text: string) => number {
	if (typeof document === "undefined") return estimate;
	const ctx = document.createElement("canvas").getContext("2d");
	if (!ctx) return estimate;
	ctx.font = font;
	return (text) => Math.ceil(ctx.measureText(text).width);
}
